<script lang="ts">
	//Design system components
	import { Label, Slider } from '@Shelly/shelly-design-system';
	//Hooks
	import { beforeUpdate, createEventDispatcher } from 'svelte';

	//Services
	import { format } from 'svelte-i18n';

	export let value: string | number = '0',
		title,
		disabled = false;

	let icon;
	const dispatch = createEventDispatcher();

	const handleChange = (e) => {
		value = e.detail.value;
		dispatch('change', value);
	};
	beforeUpdate(() => {
		icon =
			+value >= 75
				? 'fas fa-blinds'
				: +value >= 35
					? 'fas fa-blinds-open'
					: 'fas fa-blinds-raised';
	});

	const a11yProps = {
		sliderValueText: $format('current_position_value', {
			values: { value },
			default: `Current position value is ${value}`,
		}),
		ariaLabel: $format('label_cover_slider_title_position', { default: 'Position slider' }),
		ariaLabelValue: $format('current_position_value', {
			values: { value },
			default: `Current position value is ${value}`,
		}),
	};
</script>

<Slider
	id="slider-3rnm8gt"
	{a11yProps}
	{title}
	{disabled}
	class="mb-l "
	on:value_change={handleChange}
	{value}
	type={'horizontal'}
/>
